import { render, staticRenderFns } from "./placeOrderResult.vue?vue&type=template&id=e4805c36&scoped=true"
import script from "./placeOrderResult.vue?vue&type=script&lang=js"
export * from "./placeOrderResult.vue?vue&type=script&lang=js"
import style0 from "./placeOrderResult.vue?vue&type=style&index=0&id=e4805c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4805c36",
  null
  
)

export default component.exports